import { AppointmentPractitioner } from '@dreryk/egabinet-appointment-frontend-api';

import { createTranslatedText } from '@dreryk/react-common';
import { Select } from '@dreryk/react-components';

import {
   filterPractitionerByFullName,
   sortPractitionerByLastName,
   triggerLabelExtractor,
} from './PractitionerSelector.utils';

type PractitionerSelectorListProps = {
   readonly practitioners: AppointmentPractitioner[];
};

export const PractitionerSelectorList = (props: PractitionerSelectorListProps): JSX.Element => {
   return (
      <Select.Filter<AppointmentPractitioner>
         items={props.practitioners.sort(sortPractitionerByLastName)}
         filter={filterPractitionerByFullName}
      >
         {({ filteredItems }) => (
            <Select.List<AppointmentPractitioner> items={filteredItems} keyExtractor={'id'}>
               {(practitioner) => (
                  <Select.Item
                     item={practitioner}
                     testId={practitioner.id.toString()}
                     label={<Select.Highlight node={createTranslatedText(triggerLabelExtractor(practitioner))} />}
                  />
               )}
            </Select.List>
         )}
      </Select.Filter>
   );
};
